// extracted by mini-css-extract-plugin
export default {"tabsContainer":"tabsView_tabsContainer__7fF6w","tab":"tabsView_tab__Ih7Wp","activeTab":"tabsView_activeTab__WlmVj"};